import {
  InvestigationQuestion,
  InvestigationQuestionTypeEnum,
} from '@EHSNavigator/backend';
import React from 'react';
import TextArea from '../TextArea';
import Input from '../Input';
import RadioButtons from '../RadioButtons';
import clsx from 'clsx';

interface InvestigationDynamicQuestionProps {
  question: InvestigationQuestion;
  formHandler: any;
  index: number;
}

const InvestigationDynamicQuestion: React.FC<
  InvestigationDynamicQuestionProps
> = ({ question, formHandler, index }) => {
  switch (question.type) {
    case InvestigationQuestionTypeEnum.ShortAnswerText:
      return (
        <Input
          type="text"
          name={`customQuestions.${index}.answer`}
          placeholder="Write answer here..."
          value={formHandler?.values?.customQuestions[index]?.answer || ''}
          onChange={(e) => {
            formHandler.setFieldValue(
              `customQuestions.${index}.answer`,
              e.target.value,
            );
          }}
          otherClasses={{
            container: 'w-full h-fit gap-25',
            label: 'text-xl font-bold text-neutral-tones-text',
          }}
          label={
            <h6 className="font-inter-variable text-neutral-tones-text -tracking-button text-sm leading-4 font-bold lg:text-xl lg:leading-6">
              {question.question}
              <span className="text-brand-posh-pink">*</span>
            </h6>
          }
          onBlur={() =>
            formHandler.setFieldTouched(`customQuestions.${index}.answer`, true)
          }
          errorMessage={
            formHandler.touched.customQuestions?.[index]?.answer &&
            formHandler.errors.customQuestions?.[index]?.answer
              ? formHandler.errors.customQuestions[index]?.answer
              : ''
          }
        />
      );
    case InvestigationQuestionTypeEnum.LongAnswerText:
      return (
        <TextArea
          name={`customQuestions.${index}.answer`}
          placeholder="Write answer here..."
          value={formHandler?.values?.customQuestions[index]?.answer || ''}
          onChange={(e) => {
            formHandler.setFieldValue(
              `customQuestions.${index}.answer`,
              e.target.value,
            );
          }}
          otherClasses={{
            container: 'w-full gap-25 h-fit',
            label: 'text-xl font-bold text-neutral-tones-text',
          }}
          label={
            <h6 className="font-inter-variable text-neutral-tones-text -tracking-button text-sm leading-4 font-bold lg:text-xl lg:leading-6">
              {question.question}
              <span className="text-brand-posh-pink">*</span>
            </h6>
          }
          onBlur={() =>
            formHandler.setFieldTouched(`customQuestions.${index}.answer`, true)
          }
          errorMessage={
            formHandler.touched.customQuestions?.[index]?.answer &&
            formHandler.errors.customQuestions?.[index]?.answer
              ? formHandler.errors.customQuestions[index]?.answer
              : ''
          }
        />
      );

    case InvestigationQuestionTypeEnum.YesNo:
      return (
        <div className={clsx('flex flex-col gap-25')}>
          <h6 className="font-inter-variable text-neutral-tones-text -tracking-button text-sm leading-4 font-bold lg:text-xl lg:leading-6">
            {question.question}
            <span className="text-brand-posh-pink">*</span>
          </h6>
          <RadioButtons
            options={[
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ]}
            value={formHandler?.values?.customQuestions[index]?.answer || ''}
            onChange={(e) => {
              formHandler.setFieldValue(`customQuestions.${index}.answer`, e);
            }}
            errorMessage={
              formHandler.touched.customQuestions?.[index]?.answer &&
              formHandler.errors.customQuestions?.[index]?.answer
                ? formHandler.errors.customQuestions[index]?.answer
                : ''
            }
          />
        </div>
      );
    case InvestigationQuestionTypeEnum.MultiOptions:
      return (
        <div className={clsx('flex flex-col gap-25')}>
          <h6 className="font-inter-variable text-neutral-tones-text -tracking-button text-sm leading-4 font-bold lg:text-xl lg:leading-6">
            {question.question}
            <span className="text-brand-posh-pink">*</span>
          </h6>
          <RadioButtons
            options={
              question?.options?.map((option) => ({
                label: option,
                value: option,
              })) || []
            }
            value={formHandler?.values?.customQuestions[index]?.answer || ''}
            onChange={(e) => {
              formHandler.setFieldValue(`customQuestions.${index}.answer`, e);
            }}
            errorMessage={
              formHandler.touched.customQuestions?.[index]?.answer &&
              formHandler.errors.customQuestions?.[index]?.answer
                ? formHandler.errors.customQuestions[index]?.answer
                : ''
            }
          />
        </div>
      );
  }
};

export default InvestigationDynamicQuestion;
